import * as THREE from 'three';

export interface EngineMount {
  readonly local: THREE.Vector3;
  readonly plume: THREE.Mesh;
  readonly core: THREE.Mesh;
}

export interface ShipBuildResult {
  readonly engines: EngineMount[];
  readonly strobes: THREE.Mesh[];
  readonly collisionRadius: number;
}

export function createTaperedSlab(
  frontWidth: number,
  backWidth: number,
  height: number,
  length: number
): THREE.BoxGeometry {
  const geometry = new THREE.BoxGeometry(1, height, length);
  const position = geometry.attributes['position'] as THREE.BufferAttribute;

  for (let i = 0; i < position.count; i++) {
    const z = position.getZ(i);
    const t = (z + length / 2) / length;
    const width = frontWidth * (1 - t) + backWidth * t;
    position.setX(i, position.getX(i) * width);
  }
  position.needsUpdate = true;
  geometry.computeVertexNormals();
  return geometry;
}

